import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import config from '../../config.json';

import { authUserBalance, authUserBalanceCompleted, authUserBalanceFailed } from './authSlice';

export const authUserBalanceEpic = (action$) =>
	action$.pipe(
		ofType(authUserBalance),
		mergeMap(async (action) => {
			const { siteId, memberNumber } = action.payload;

			const response = await axios.get(
				`${config[process.env.REACT_APP_STAGE].api}/userBalance/${siteId}/${memberNumber}`
			);

			return response.data;
		}),
		switchMap((res) => [authUserBalanceCompleted(res.data)]),
		catchError((error, source) => merge(of(authUserBalanceFailed(error.message)), source))
	);

export default [authUserBalanceEpic];
